import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';

const prefix = '[StartManyProductionInstances] ';

export const startManyProductionInstances = createAction(
  `${prefix} Start Many Production Instances`,
  props<{ ids: UUID[] }>()
);

export const startManyProductionInstancesSuccess = createAction(
  `${prefix} Start Many Production Instances Success`,
  props<{ ids: UUID[] }>()
);

export const startManyProductionInstancesFailure = createAction(
  `${prefix} Start Many Production Instances Failure`,
  props<{ error: any }>()
);

export const clearStartManyProductionInstancesState = createAction(
  `${prefix} Clear Start Many Production Instances State`
);
